export default "__VITE_ASSET__c9W5zFX9__"